// Tenant and Contractor sessions don't carry org-module permission levels at all (that's an
// org-user-only concept) -- their access is enforced by backend ownership instead. Service
// Request pages use this to bypass the ServiceRequest module-permission gate (hasAccess /
// PermissionGuard) and to unlock write-affordances (onEdit/onAddNote) for those two roles even
// when canWrite("ServiceRequest") is false. Shared between src/pages/service-request/index.tsx
// and src/pages/service-request/ServiceRequestDetails.tsx so the two copies can't drift.
export const isTenantOrContractorRole = (
  userRole?: "Landlord" | "Tenant" | "Contractor"
): boolean => userRole === "Tenant" || userRole === "Contractor";
